import { Mask, Image, Button } from "antd-mobile";
import React, { FC, memo } from "react";
import styles from "./index.module.less";
import { question_answermask } from "~src/assets/images/answerGame";
import { TopIconType } from "~src/service/answer/answer";
import MaskContentTopIcon from "./MaskContentTopIcon";


interface MaskProps {
  visible: boolean;
  topIcon: TopIconType;
  title?: string;
  timer?: number;
  desc?: string | JSX.Element;
  handleComplete?: () => void;
  onMaskClick: () => void;
  onOk: () => void;
  okText?: string;
  onCancel?: () => void;
  cancelText?: string;
}


const MaskContent: FC<MaskProps> = ({
  visible = false,
  title = "",
  desc = "",
  topIcon,
  timer=5,
  onMaskClick,
  handleComplete=()=>void 0,
  okText = "确定",
  onOk,
  onCancel,
  cancelText = "取消"
}) => {

  return <Mask
    visible={visible}
    onMaskClick={onMaskClick}
    opacity={.6}>
    <div className={styles.mask}>
      <div className={styles["mask-top"]}>
        <MaskContentTopIcon topIcon={topIcon} handleComplete={handleComplete} timer={timer}></MaskContentTopIcon>
      </div>
      <div className={styles["mask-cont"]}>
        <Image className={styles.question_answermask} src={question_answermask}></Image>
        <div className={styles["mask-boby"]}>
          <div className={styles["mask-boby-title"]}>{title}</div>
          <div className={styles["mask-boby-dec"]}>{desc}</div>
          <div className={styles["mask-footer"]}>
            <Button className={styles["mask-footer-ok"]} onClick={onOk}>{okText}</Button>
            {
              onCancel && <div className={styles["mask-footer-close"]} onClick={onCancel}>{cancelText}</div>
            }
          </div>
        </div>
      </div>
    </div>
  </Mask>
}
export default memo(MaskContent)
